import React from 'react'
import Modal from 'react-modal'

const customStyle = {
  content: {
    background: 'none',
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    top: 59,
    overflowY: 'auto',
    padding: 0
  },
  overlay: {
    background: 'rgba(60, 66, 82, 0.85)',
    zIndex: 10
  }
}

function CustomModal(props) {
  const { children, isOpen } = props
  return (
    <Modal isOpen={isOpen} style={customStyle} ariaHideApp={false}>
      {children}
    </Modal>
  )
}

export default CustomModal



// WEBPACK FOOTER //
// ./src/components/container/modal/modal.js